import styled from 'styled-components';
import {OfferCard, OfferCardExternal} from 'components/upselling/OfferCard';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  width: 100%;
  gap: 32px;
  align-items: start;

  @media (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const StyledOfferCard = styled(OfferCard)`
  max-width: none;
  width: 100%;
  min-width: 0;
`;

export const StyledGuruWalkOfferCard = styled(OfferCardExternal)`
  max-width: none;
  width: 100%;
  min-width: 0;
`;

export const DesktopActionPanel = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 16px 32px 24px;
`;

export const MobileActionPanel = styled.div`
  display: flex;
  gap: 16px;
  background: ${props => props.theme.colors.branding.boxesModals};
  box-shadow: 0 2px 10px rgba(147, 150, 174, 0.25);
  padding: 24px;
  align-items: center;
  & > * {
    flex-grow: 1;
  }
`;
